import { Crown, Sparkles } from 'lucide-react';

export default function ErnieProBanner({ onUpgradeClick, monthlyPrice = 5.99 }) {
  return (
    <div className="mb-6 bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-500 rounded-lg shadow-lg overflow-hidden">
      <div className="p-6">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-3">
            <Crown className="w-8 h-8 text-yellow-900" />
            <div>
              <h3 className="text-xl font-bold text-yellow-900 flex items-center gap-2">
                Unlock Unlimited Ernie AI
                <Sparkles className="w-5 h-5" />
              </h3>
              <p className="text-yellow-800 text-sm mt-1">
                Ask about anything - coding, business, creative projects & more!
              </p>
            </div>
          </div>
          
          <button
            onClick={onUpgradeClick}
            className="px-6 py-3 bg-yellow-900 text-yellow-50 font-bold rounded-lg hover:bg-yellow-800 transition-colors shadow-lg flex items-center gap-2"
            data-testid="upgrade-to-pro-btn"
          >
            <Crown className="w-5 h-5" />
            Upgrade to Pro - ${monthlyPrice}/month
          </button>
        </div>
        
        <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-3 text-yellow-900 text-sm">
          <div className="flex items-start gap-2">
            <span className="font-bold">✓</span>
            <span>Unlimited topics & questions</span>
          </div>
          <div className="flex items-start gap-2">
            <span className="font-bold">✓</span>
            <span>Premium AI model access</span>
          </div>
          <div className="flex items-start gap-2">
            <span className="font-bold">✓</span>
            <span>Personal memory feature</span>
          </div>
        </div>
      </div>
    </div>
  );
}
